module.exports = __webpack_public_path__ + "img/tick-icon.7247ec0b.jpg";